import React, { useState } from 'react';
import { ClipboardList, Search, CalendarX } from 'lucide-react';

import MapaCaixaRegistro from './MapaCaixaRegistro';
import MapaCaixaConsulta from './MapaCaixaConsulta';
import MapaCaixaPendencias from './MapaCaixaPendencias';
import { perfilNoModulo } from '../../../utils/perfisDerivados';

// =====================================================================
// FINANCEIRO — Mapa de Caixa: a CASCA do sub-módulo.
//
// Um card só no hub do Financeiro, com as duas telas em abas internas
// (Lançar · Consulta · Pendências) — o padrão dos vizinhos Cofrinho / Nulos / Estorno.
//
// A loja digitaliza o "Controle Diário" de papel: anexa o scan e transcreve os
// totais de resumo, por loja/dia. O escritório consulta a rede.
//
// ⚠️ `Diretoria` é SOMENTE LEITURA aqui: acompanha a rede, não fecha o caixa de
//    uma loja. A aba de lançamento nem aparece — a trava real é o
//    `authorizeRoles`/`PERFIS_DIGITACAO` do backend; aqui é só a aba.
// =====================================================================

const COR = '#0d7a74';       // paleta do Financeiro (verde-petróleo)
const COR_FORTE = '#115e59';
const COR_FUNDO = '#f0fdfa';

const MapaCaixa = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userRole = perfilNoModulo(user?.perfil, 'financeiro') || '';

    // ⚠️ LISTA, não `===`: quem só acompanha a rede (Diretoria) lê e não lança.
    const PERFIS_SO_LEITURA = ['Diretoria'];
    const somenteLeitura = PERFIS_SO_LEITURA.includes(userRole);

    const [aba, setAba] = useState(somenteLeitura ? 'consulta' : 'lancar');

    const estiloAba = (ativa) => ({
        display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px',
        backgroundColor: ativa ? COR_FUNDO : 'transparent',
        color: ativa ? COR_FORTE : '#64748b',
        border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer',
        transition: 'all 0.2s', fontSize: 14,
        boxShadow: ativa ? `inset 0 -2px 0 ${COR}` : 'none',
    });

    const conteudo = () => {
        // Pendências: todo perfil que abre o módulo vê (o recorte por loja é do backend).
        if (aba === 'pendencias') return <MapaCaixaPendencias />;
        if (somenteLeitura || aba === 'consulta') return <MapaCaixaConsulta />;
        return <MapaCaixaRegistro onIrParaConsulta={() => setAba('consulta')} />;
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <div style={{
                display: 'flex', flexWrap: 'wrap', gap: 12,
                borderBottom: '1px solid #e2e8f0', paddingBottom: 16,
            }}>
                {!somenteLeitura && (
                    <button onClick={() => setAba('lancar')} style={estiloAba(aba === 'lancar')}>
                        <ClipboardList size={18} /> Lançar Mapa
                    </button>
                )}
                <button onClick={() => setAba('consulta')} style={estiloAba(aba === 'consulta' || (somenteLeitura && aba !== 'pendencias'))}>
                    <Search size={18} /> Consulta
                </button>
                <button onClick={() => setAba('pendencias')} style={estiloAba(aba === 'pendencias')}>
                    <CalendarX size={18} /> Pendências
                </button>
            </div>

            <div style={{ paddingTop: 8 }}>
                {conteudo()}
            </div>
        </div>
    );
};

export default MapaCaixa;
